export const LOAD_SLAB_AJAX_SUCCESS = "LOAD_SLAB_AJAX_SUCCESS";
export const SAVE_SLAB_SEARCH_CRITERIA = "SAVE_SLAB_SEARCH_CRITERIA";
export const SLAB_AJAX_SUCCESS = "SLAB_AJAX_SUCCESS";
